import { render } from "./KwsNewsIcon.vue?vue&type=template&id=45114818"
import script from "./KwsNewsIcon.vue?vue&type=script&lang=js"
export * from "./KwsNewsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__